// Content constants for Lionhead International site
export const CONTACT = {
  email: "info@lionheadint.com",
  dispatchEmail: "dispatch@lionheadint.com",
  phone: "(888) 286-9244",
  phoneTel: "+18882869244",
  address: {
    line1: "4300 Business Park Ct",
    line2: "Lilburn, GA 30047",
  },
  hours: {
    office: "Mon–Sat · 7:00 – 19:00 ET",
    emergency: "24/7 Roadside & Dispatch",
  },
};

export const STATUS_PILLS = [
  { label: "GA Depot Online", live: true },
  { label: "99.4% On-Time", live: false },
  { label: "24/7 Roadside", live: true },
  { label: "HQ · Lilburn, GA", live: false },
];

export const MARQUEE_ITEMS = [
  "Long-Haul Freight",
  "Refrigerated & Dry Van",
  "Intermodal Drayage",
  "Fleet Diagnostics",
  "DOT Inspections",
  "Engine Overhaul",
  "Transmission Rebuilds",
  "Roadside Recovery",
  "Tire & Brake",
  "Trailer Repair",
  "Warehousing",
  "Cross-Docking",
];

export const STATS = [
  { value: 99.4, suffix: "%", label: "On-Time Delivery" },
  { value: 24, prefix: "", suffix: "M+", label: "Miles Logged Annually" },
  { value: 24, suffix: "/7", label: "Roadside Assistance" },
  { value: 3400, suffix: "+", label: "Fleet Units Served" },
];

export const SERVICES = [
  {
    id: "freight",
    kicker: "Chapter 01",
    title: "Freight & Trucking",
    tagline: "Coast-to-coast capacity, on our own iron.",
    image:
      "https://images.unsplash.com/photo-1519003722824-194d4455a60c?w=1400&q=80&auto=format&fit=crop",
    bullets: [
      "Dedicated OTR lanes across the lower 48",
      "Refrigerated, dry van, and flatbed fleets",
      "GPS-tracked shipments with hourly ETA",
      "Owner-operator payouts on 24-hour terms",
    ],
    formValue: "Freight & Trucking",
  },
  {
    id: "logistics",
    kicker: "Chapter 02",
    title: "Logistics & Supply Chain",
    tagline: "Warehousing, drayage, and cross-dock — orchestrated.",
    image:
      "https://images.unsplash.com/photo-1553413077-190dd305871c?w=1400&q=80&auto=format&fit=crop",
    bullets: [
      "3PL warehousing with real-time inventory",
      "Port drayage across Savannah, Charleston, Jacksonville",
      "Cross-docking and last-mile consolidation",
      "Custom API integrations for shipper systems",
    ],
    formValue: "Logistics & Supply Chain",
  },
  {
    id: "repair",
    kicker: "Chapter 03",
    title: "Truck & Trailer Repair",
    tagline: "Heavy-duty mechanics who moonlight for nobody.",
    image:
      "https://images.unsplash.com/photo-1487754180451-c456f719a1fc?w=1400&q=80&auto=format&fit=crop",
    bullets: [
      "Diesel engine diagnostics & complete overhauls",
      "Allison / Eaton transmission rebuilds",
      "DOT inspection & preventive maintenance",
      "Mobile roadside service within 100 mi of Lilburn",
    ],
    formValue: "Truck & Trailer Repair",
  },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Zero Downtime",
    body:
      "A truck that doesn't roll doesn't earn. Our shop keeps a rolling parts inventory, second-shift diagnostics, and a promise: any tractor in the bay by 7 AM leaves before dinner.",
  },
  {
    num: "02",
    title: "Precision Mechanics",
    body:
      "Every technician is ASE-certified with a decade of diesel under the fingernails. Torque specs are photographed. Rebuilds are logged. The work speaks in miles, not in marketing.",
  },
  {
    num: "03",
    title: "Driver-First Culture",
    body:
      "Drivers eat first. Home time is scheduled, not negotiated. Pay rides on the mile, not on a spreadsheet. If a load asks a driver to break the law, that load isn't ours.",
  },
  {
    num: "04",
    title: "Built for the Long Haul",
    body:
      "We're a family business. The trucks we service today will roll for the fleets our kids run. That kind of timeline changes how you build — slower, sturdier, and with the receipts to prove it.",
  },
];

export const GALLERY = [
  {
    caption: "OTR Sleeper — Kenworth W990",
    image:
      "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?w=1200&q=80&auto=format&fit=crop",
  },
  {
    caption: "Engine Overhaul Bay — Cummins X15",
    image:
      "https://images.unsplash.com/photo-1487754180451-c456f719a1fc?w=1200&q=80&auto=format&fit=crop",
  },
  {
    caption: "Drivetrain Master Tech at Work",
    image:
      "https://images.unsplash.com/photo-1632823471565-1ecdf5c6d7fa?w=1200&q=80&auto=format&fit=crop",
  },
  {
    caption: "Intermodal Port Partner — Savannah",
    image:
      "https://images.unsplash.com/photo-1494412651409-8963ce7935a7?w=1200&q=80&auto=format&fit=crop",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Lionhead pulled two of our tractors out of a Kentucky mud pit at 3 AM and had both back in service by the next afternoon. No other outfit even answered the phone.",
    name: "Rachel Okafor",
    role: "Ops Director, Meridian Cold Chain",
  },
  {
    quote:
      "We moved 1,800 SKUs through their Lilburn warehouse in the fourth quarter and lost exactly zero to damage. That number used to be forty-something.",
    name: "Devon Hartley",
    role: "VP Logistics, Sable Home Goods",
  },
  {
    quote:
      "Rebuilt an Allison HD 4500 for us in three days. Dealer quoted three weeks. Lionhead's invoice was half. Bill's crew is unreasonable in the best way.",
    name: "Maria Alvarado",
    role: "Fleet Manager, Coastal Aggregate Co.",
  },
];

export const CAREERS = {
  driver: {
    title: "Company Drivers & Owner-Operators",
    benefits: [
      "$0.68–$0.82 per mile, paid weekly with no held-back deposit",
      "Home every weekend on dedicated Southeast lanes",
      "2023-and-newer sleeper trucks with APU + inverter",
      "Full medical, dental, 401(k) with 4% match",
      "Referral bonuses up to $3,500 per hired driver",
    ],
  },
  mechanic: {
    title: "Diesel Technicians & Trailer Mechanics",
    benefits: [
      "$32–$46/hr based on ASE certifications and years",
      "Signing bonus up to $8,000 for master-level techs",
      "Boot and tool allowance renewed annually",
      "Four-day work week option after 90 days",
      "Paid ASE recertification and manufacturer training",
    ],
  },
  roles: [
    "Company Driver — OTR",
    "Company Driver — Regional",
    "Owner-Operator",
    "Diesel Technician",
    "Trailer Mechanic",
    "Dispatch Coordinator",
    "Warehouse Associate",
  ],
};
